export default __webpack_public_path__ + "static/media/iconSport.edc6d992.svg";